import { LedgerTransactionFilter } from "types/navigation/ledgerTransactionNavigation";

export const DEFAULT_LEDGER_TRANSACTION_TABLE_SORT = {
  id: "created_at",
  desc: false,
};

export const BASE_LEDGER_TRANSACTION_FILTERS: LedgerTransactionFilter = {};
